import React from "react";
import styled from "styled-components";

function Footer2() {
  return (
    <>
      <FooterWrapper></FooterWrapper>
    </>
  );
}

export default Footer2;

const FooterWrapper = styled.div`
  position: absolute;s
  bottom: 0;
  left: 0;
  right: 0;
  background: #ff832e;
  height: auto;
  width: 100vw;
  padding-top: 40px;
  color: #fff;
`;
